import FormLabel from '@material-ui/core/FormLabel';
import { withStyles } from '@material-ui/core/styles';

const Label = withStyles(theme => ({
  root: {
    display: 'flex',
    fontSize: 14,
    color: '#08090a',
    marginBottom: 5,
    alignItems: 'center',
    gap: 8,
    gridGap:8
  },
  focused: { color: '#08090a !important' }

}))(FormLabel);

export default Label;
